<template>
  <div class="sidebar" v-bind:class="{forceVisible: forceSidebarVisible}">
    <div class="header">
      <img src="../assets/images/powerslide-white.svg" class="logo" alt="Powerslide Logo" />
    </div>

    <div class="nav-wrapper">
      <!-- <div class="sidebar-nav-item subscribe" v-bind:class="{ active: isPaneSelected('subscribe') }" v-on:click="setSelectedPane('subscribe')">
        <img src="../assets/images/cart-icon.svg" class="icon" alt="Subscribe" />
        <span>Subscribe</span>
      </div> -->
      <div class="sidebar-nav-item" v-bind:class="{ active: isPaneSelected('slide-builder') }" v-on:click="setSelectedPane('slide-builder')">
        <img src="../assets/images/construction-icon.svg" class="icon" alt="Slide Builder" />
        <span>Slide Builder</span>
      </div>
      <div class="sidebar-nav-item" v-bind:class="{ active: isPaneSelected('slideshows') }" v-on:click="setSelectedPane('slideshows')">
        <img src="../assets/images/slideshow-icon.svg" class="icon" alt="Slideshows" />
        <span>Slideshows</span>
      </div>
      <!-- <div class="sidebar-nav-item" v-bind:class="{ active: isPaneSelected('device-management') }" v-on:click="setSelectedPane('device-management')">
        <img src="../assets/images/screen-icon.svg" class="icon" alt="Device Management" />
        <span>Screens</span>
      </div> -->
      <!-- <div class="sidebar-nav-item" v-bind:class="{ active: isPaneSelected('menu-builder') }" v-on:click="setSelectedPane('menu-builder')">
        <img src="../assets/images/food-icon.svg" class="icon" alt="Menu Builder" />
        <span>Menu Builder</span>
      </div> -->
      <div class="sidebar-nav-item" v-bind:class="{ active: isPaneSelected('tutorials') }" v-on:click="setSelectedPane('tutorials')">
        <img src="../assets/images/tutorial-icon.svg" class="icon" alt="Tutorials" />
        <span>Tutorials</span>
      </div>
      <div class="sidebar-nav-item" v-bind:class="{ active: isPaneSelected('organization') }" v-on:click="setSelectedPane('organization')">
        <img src="../assets/images/user.svg" class="icon" alt="Organization" />
        <span>Organization</span>
      </div>
      <div class="sidebar-nav-item" v-bind:class="{ active: isPaneSelected('users') }" v-on:click="setSelectedPane('users')">
        <img src="../assets/images/users-icon.svg" class="icon" alt="Users" />
        <span>Users</span>
      </div>
      <div class="sidebar-nav-item" v-bind:class="{ active: isPaneSelected('profile') }" v-on:click="setSelectedPane('profile')">
        <img src="../assets/images/user.svg" class="icon" alt="Profile" />
        <span>Profile</span>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'
import Helpers from '../mixins/helpers.js'

export default {
  name: 'Sidebar',

  components: {
    Helpers
  },

  data () {
    return {
      forceSidebarVisible: false,
      loading: false
    }
  },

  methods: {
    isPaneSelected: function (pane) {
      return pane === this.$parent.selectedPane
    },

    setSelectedPane: function (pane) {
      this.$parent.setSelectedPane(pane)
    }

    // permVisible: function () {
    //   if (!this.isEmptyObject(PS.user)) {
    //     return PS.user.role === 'owner' || PS.user.role === 'manager'
    //   }
    //  }
  },

  mixins: [Helpers],

  props: ['forceVisible', 'refresh'],

  watch: {
    forceVisible: function (newVal, oldVal) {
      this.forceSidebarVisible = newVal
    },

    refresh: function (newVal, oldVal) {
      PS.user = JSON.parse(localStorage.getItem('user'))
    }
  }
}
</script>

<style scoped>
  .active {
    background: var(--secondary);
    box-shadow: 0px 5px 7px 1px rgba(39,39,39,.3)
  }

  .button-icon {
    left: 4px;
  }

  .forceVisible {
    left: 0 !important;
  }

  .header {
    color: var(--sidebar-text);
    font-size: 20px;
    padding: .9em 0 0 0;
    position: relative;
    text-align: center;
  }

  .icon {
    bottom: 4px;
    height: 22px;
    opacity: .8;
    position: relative;
    vertical-align: middle;
  }

  .logo {
    width: 160px;
  }

  .logout {
    left: 3px;
    position: relative;
  }

  .sidebar-separator {
    background: var(--sidebar-text);
    border: none;
    height: .5px;
    opacity: .5;
    width: 228px;
  }

  .subscribe {
    background: var(--secondary) !important;
  }

  .nav-wrapper {
    margin: 10px 0 0 0;
    border-radius: 30px;
    color: #fff;
    display: block;
    text-decoration: none;
    position: relative;
    cursor: pointer;
    font-size: .7142em;
    line-height: 1.625rem;
  }

  .sidebar {
    background-color: var(--sidebar-bg);
    bottom: 0;
    box-shadow: 3px 0px 9px 0px rgba(0,0,0,.5);
    float: left;
    left: 0;
    min-height: 100vh;
    position: sticky;
    top: 0;
    transition: all .3s ease 0s;
    width: 260px;
    z-index: 999;
  }

  @media only screen and (max-width: 991px) {
    .sidebar {
      left: -260px;
    }
  }

  .sidebar-nav-button {
    background: var(--secondary);
    border: none;
    color: white;
    cursor: pointer;
    font-size: 20px;
    padding: 1em;
    text-align: left;
    width: 100%;
  }

  .sidebar-nav-button:focus {
    outline: none;
  }

  .sidebar-nav-item {
    padding: 1.5em 2em;
    text-align: left;
    width: 100%;
  }

  .sidebar-nav-item:hover {
    background: var(--sidebar-button-hover);
  }

  .subscribe:hover {
    background: var(--secondary-dark) !important;
  }

  span {
    font-size: 20px;
    padding-left: .75em;
    position: relative;
    top: 1;
  }
</style>
